<button type="button" class="btn btn-dark btn-lg btn-block rounded-0 border-0 text-left p-0 d-flex flex-row" [routerLink]="['topic', topic.id]">
  <div class="thumbnail-container" *ngIf="thumbnailFile">
    <video *ngIf="isVideo" [src]="thumbnailFile.fileUrl + '#t=0.1'" preload="auto" muted class="thumb-media"></video>
    <img *ngIf="!isVideo" [src]="thumbnailFile.fileUrl" class="thumb-media" alt="Thumbnail">
    <div class="play-overlay" *ngIf="isVideo">
      <svg viewBox="0 0 24 24" fill="white" width="24" height="24">
        <polygon points="5,3 19,12 5,21"/>
      </svg>
    </div>
  </div>

  <div class="topic-item-container p-0 d-flex flex-column justify-content-center">
      <span class="topic-title p-0 font-weight-light">{{topic.displayName}}</span>
      <span class="topic-documents p-0 text-secondary text-uppercase">{{topic.files?.length || 0}} {{topic.files?.length === 1 ? 'document' : 'documents'}}</span>
  </div>

</button>
